// extracted by mini-css-extract-plugin
export default {"cls1":"ModalError-cls1_VjV","cls2":"ModalError-cls2__GT ModalError-cls1_VjV"};